<script setup lang="ts">
definePage({
  meta: {
    layout: 'default',
    title: 'PageNotFound',
    hidden: true,
  },
})
</script>

<template>
  <h1>Page Not Found</h1>
</template>

<style scoped lang="less"></style>
